/** @jsxImportSource @emotion/react */
import React, {Component} from 'react'
import Button, {ButtonProps} from '@mui/material/Button'
import { StylesObject } from 'types';

export type PromiseButtonProps = {
  className?: string;
  onClick?: NonNullable<ButtonProps['onClick']>;
} & ButtonProps
export class PromiseButton extends Component<PromiseButtonProps> {
  _mounted: boolean | undefined

  state = {loading: false, success: false, error: false}

  componentDidMount = () => {
    this._mounted = true
  }

  componentWillUnmount = () => {
    this._mounted = false
  }

  showStatus = (status) => {
    if (this._mounted) {
      this.setState({[status]: true})
      setTimeout(() => {
        if (this._mounted)
          this.setState({[status]: false})
      }, 3000)
    }
  }

  handleClick = async(event) => {
    this.setState({loading: true})
    try {
      this.props.onClick && (await this.props.onClick(event))
      this.showStatus('success')
    }
    catch(_ex) {
      this.showStatus('error')
    }
    finally {
      if (this._mounted)
        this.setState({loading: false})
    }
  }

  render = () => {
    const {loading, success, error} = this.state
    const {className, ...props} = this.props
    return (
      <Button {...props} onClick={this.handleClick} css={[styles.root, loading && styles.loading, success && styles.success, error && styles.error]}/>
    )
  }

}

const styles = {
  root: {
    transition: 'backgroundColor 500ms',
  },
  loading: {
    backgroundColor: '#999',
    pointerEvents: 'none',
  },
  success: ({palette}) => ({
    backgroundColor: `${palette.success.main} !important`,
  }),
  error: ({palette}) => ({
    backgroundColor: `${palette.error.main} !important`,
  })
} as StylesObject

export default PromiseButton